import {
  boolean,
  integer,
  jsonb,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid
} from 'drizzle-orm/pg-core';

import { jobs } from './jobs';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const competencies = pgTable(
  'competencies',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    name: text('name').notNull(),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    uniqueIndex('competencies_org_name_unique').on(t.tenantId, t.orgId, t.name),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();

export const questionCategoryEnum = pgEnum('question_category', [
  'eligibility',
  'nice_to_have',
  'job_expectations',
  'assessment',
  'information'
]);

export type QuestionCategory = (typeof questionCategoryEnum.enumValues)[number];

export const interviewQuestions = pgTable(
  'interview_questions',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    jobId: uuid('job_id')
      .notNull()
      .references(() => jobs.id),
    category: questionCategoryEnum('category').notNull(),
    text: text('text').notNull(),
    position: integer('position').notNull(),
    isOptional: boolean('is_optional').notNull().default(false),
    competencyId: uuid('competency_id').references(() => competencies.id),
    scoringExamples: jsonb('scoring_examples'), // { score1, score3, score5 } | null
    aiGenerated: boolean('ai_generated').notNull().default(false),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  () => [tenantOrgIsolationPolicy()]
).enableRLS();
